<ng-container *ngIf="{
  deviceId: _deviceId$ | async,
  statusEvcharge: statusEvcharge$ | async,
  selectedEvchargeProperties: selectedEvchargeProperties$ | async
} as resolver">
  <app-generic-device-dashboard
    titleId="evcharge-title"
    [title]="labels.title"
    [uiFramework]="uiFramework"
    [status]="resolver.statusEvcharge"
    [deviceId]="resolver.deviceId"
    deviceTypeLabel="wallbox"
    [defaultImageSrc]="'blocks-assets/images/productImages/other/wallbox.svg'"
    [properties]="resolver.selectedEvchargeProperties">
  </app-generic-device-dashboard>
</ng-container>